import { useEffect, useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser, fmt } from "../../lib/api";
import { Link } from "react-router-dom";

export default function MyPackages() {
  const user = readUser();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/user-packages").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <MemberLayout user={user} active="My Packages">
      <div className="table-panel">
        <div className="panel-heading">
          <div><span className="eyebrow">ACTIVE & COMPLETED</span><h3>My packages</h3></div>
          <Link to="/dashboard/deposits" className="btn btn-light" data-testid="activate-new-package">Activate new</Link>
        </div>
        <div className="table-wrap">
          <table className="member-packages-table">
            <thead>
              <tr>
                <th>Package</th><th>Price</th><th>Daily</th><th>Next credit</th><th>Start</th><th>End</th><th>Accumulated</th><th>Days left</th><th>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p, i) => (
                <tr key={i} data-testid={`my-package-${i}`}>
                  <td data-label="Package">{p.package_name}</td>
                  <td data-label="Price">${fmt(p.price)}</td>
                  <td data-label="Daily">${fmt(p.daily_production)}</td>
                  <td data-label="Next credit" data-testid={`my-package-next-credit-${i}`}>{p.first_production_at && new Date(p.first_production_at) > new Date() ? new Date(p.first_production_at).toLocaleString() : "Daily at 00:05 UTC"}</td>
                  <td data-label="Start">{new Date(p.start_date).toLocaleDateString()}</td>
                  <td data-label="End">{new Date(p.end_date).toLocaleDateString()}</td>
                  <td data-label="Accumulated">${fmt(p.accumulated_production)}</td>
                  <td data-label="Days left">{p.remaining_days}</td>
                  <td data-label="Status"><span className={`status ${p.status.toLowerCase()}`}>{p.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {!rows.length && <div className="table-empty">No packages yet. Submit a deposit to activate one.</div>}
        </div>
      </div>
    </MemberLayout>
  );
}
